export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_ID
